import { render, staticRenderFns } from "./LeadsAccessHeader.vue?vue&type=template&id=e846fdfc&scoped=true"
import script from "./LeadsAccessHeader.vue?vue&type=script&lang=js"
export * from "./LeadsAccessHeader.vue?vue&type=script&lang=js"
import style0 from "./LeadsAccessHeader.vue?vue&type=style&index=0&id=e846fdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e846fdfc",
  null
  
)

export default component.exports